import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteCoupon } from "./deleteCoupon.request";

const useCouponDelete = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteCoupon,
    ...options
  });
};

export default useCouponDelete;
